import type { TDatadogErrorLog } from 'utils/datadog/types'

export const DELETE_DASHBOARD_FOLDER_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/delete-dashboard-folder-modal',
  name: 'Deletes Dashboard Folder',
  message: 'Failed to delete the Dashboard Folder',
}
